import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field label large" }
const _hoisted_2 = { class: "field label large" }
const _hoisted_3 = { class: "field label large" }
const _hoisted_4 = { class: "field label large" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tickets_input = _resolveComponent("tickets-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_tickets_input, {
        label: "Titel *",
        cy: "summary",
        modelValue: $setup.editGame.summary,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.editGame.summary) = $event)),
        val: $setup.v$.summary
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_tickets_input, {
        label: "Start *",
        cy: "start",
        type: "datetime-local",
        modelValue: $setup.editGame.dtstart,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.editGame.dtstart) = $event)),
        val: $setup.v$.dtstart
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_tickets_input, {
        label: "Ende *",
        cy: "end",
        type: "datetime-local",
        modelValue: $setup.editGame.dtend,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.editGame.dtend) = $event)),
        val: $setup.v$.dtend
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_tickets_input, {
        label: "Ort *",
        cy: "location",
        modelValue: $setup.editGame.location,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.editGame.location) = $event)),
        val: $setup.v$.location
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("button", {
        class: "round primary",
        disabled: $setup.v$.$errors.length > 0,
        onClick: $setup.save,
        "data-cy": "savegame"
      }, "Speichern", 8, _hoisted_5),
      _createElementVNode("button", {
        class: "round secondary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.emit('cancel'))),
        "data-cy": "canceleditgame"
      }, "Abbrechen")
    ])
  ], 64))
}